import axios from 'axios'

/**
 * API for getting list of tenants
 */
export const getListOfRoles = async () => {
  const response = await axios.get(`roles`)
  return response
}

export const getDemoUserToken = async () => {
  const response = await axios.get(`/auth/demo-token`)
  return response
}
